import Swiper, {A11y, Autoplay, EffectFade, Navigation, Pagination} from 'swiper'

const body = document.querySelector('body');
const home = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([A11y, Autoplay, EffectFade, Navigation, Pagination]);

        let config = {
            speed: 700,
            loop: true,
            allowTouchMove: false,

            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Navigation (arrow)
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },

            // Pagination (bullet)
            pagination: {
                el: '.slideshow__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if (dataSlideAuto === '1') {
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if (nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);

            if(dataSlideAuto === '1') {
                let boutonPlayPause = document.getElementById('js-boutonAutoplay')

                boutonPlayPause.addEventListener('click', function () {

                    if(swiperHome.autoplay.running === true) {
                        swiperHome.autoplay.stop();

                        boutonPlayPause.classList.remove('slideshow__navigation__btn--play')
                        boutonPlayPause.classList.add('slideshow__navigation__btn--pause');

                        // console.log('autoplay running : ' + swiperHome.autoplay.running);
                    }

                    else {
                        swiperHome.autoplay.start();

                        boutonPlayPause.classList.remove('slideshow__navigation__btn--pause')
                        boutonPlayPause.classList.add('slideshow__navigation__btn--play');

                        // console.log('autoplay running : ' + swiperHome.autoplay.running);
                    }
                });
            }
        }
    }


    // slider Agenda
    const eventsSlideshow = document.querySelector('.events .swiper-container') !== null;
                
    if (eventsSlideshow) {
        let eventsSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let eventsConfig = {
            effect : 'slide',
            grabCursor : 'false',
            speed: 700,
            loop: false,
            slidesPerView: 'auto',

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                prevEl: `.js-events-swiper-nav--prev`,
                nextEl: `.js-events-swiper-nav--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    spaceBetween: 25,  
                    slidesPerView: 3,

                },
        
                961: {
                    spaceBetween: 20, 
                    slidesPerView: 3,
                },
                
                641: {
                    spaceBetween: 20,
                    slidesPerView: 2.2,

                },
        
                0: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }
            }
        }

        let swiperevents = new Swiper('.events .swiper-container', eventsConfig);

        function updateMargins() {
            let slides = document.querySelectorAll('.events .swiper-container .swiper-slide');

            slides.forEach(function (slide) {
                slide.style.marginTop = '0px';
            });

            let activeIndex = swiperevents.activeIndex;

            if (activeIndex >= 0 && activeIndex < slides.length) {
                slides[activeIndex].style.marginTop = '0px';

                for (let i = 1; i <= slides.length - 1; i++) {
                    let nextIndex = (activeIndex + i) % slides.length;
                    slides[nextIndex].style.marginTop = (i % 2 === 1) ? '55px' : '0px' ;
                }
            }
        }

        function progressBar() {
            let progressContainer = document.querySelector('.js-events__progress');
            let progressBar = document.querySelector('.js-events__progress-bar');

            let totalSlides = swiperevents.slides.length;
            let currentIndex = swiperevents.activeIndex + 1; // +1 to make it 1-based index
            let progressPercent = ((currentIndex * 2) / totalSlides) * 100;
            if(progressBar) {
                progressBar.style.width = progressPercent + '%';
            }
        }

        if(window.innerWidth > 640) {
            swiperevents.on('slideChange', updateMargins);
            swiperevents.on('slideChange', progressBar);

            updateMargins();
            progressBar();
        }
    }
}
